import { Form } from "react-bootstrap"

import { TitleH3 } from "../../../components/TitleH3"
import { Text } from "../../../components/Text"
import { moduleTotal, moduleMaxTotal } from "../examUtils"

import structure_img from "../assets/images/structure.svg"
import right_img from "../assets/images/right.svg"
import check_img from "../../../assets/images/check.svg"

export default function ExamCustomizeModuleCard ({ module, rows, customized, included, canToggleOff, showTimeInput, time, t, onStepperChange, onOpenSheet, onTimeChange, onToggleIncluded }) {

    const hasTopics = rows && rows.length > 0
    const total = hasTopics ? moduleTotal(rows) : 0
    const maxTotal = hasTopics ? moduleMaxTotal(rows) : 0

    return (
        <div className="border mt-3 mb-2 p-3 exam_customize_card">
            <TitleH3 className="text-center"><img src={structure_img} alt="" className="me-2" />{module.module_name}</TitleH3>

            {hasTopics &&
                <div className="d-flex justify-content-between align-items-center mt-3">
                    <Text className="mb-0">{t.exam.customize.include_module}</Text>
                    <Form.Check
                        type="switch"
                        checked={included}
                        disabled={included && !canToggleOff}
                        onChange={onToggleIncluded}
                    />
                </div>
            }

            {hasTopics && included &&
                <>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <Text className="mb-0">{t.exam.customize.total_label}</Text>
                        <div className="exam_customize_stepper">
                            <button type="button" disabled={total <= 0} onClick={() => onStepperChange(-1)}>–</button>
                            <span>{total} {t.exam.customize.questions_unit}</span>
                            <button type="button" disabled={total >= maxTotal} onClick={() => onStepperChange(1)}>+</button>
                        </div>
                    </div>

                    <div className="d-flex justify-content-between align-items-center mt-3 exam_customize_topics_link" onClick={onOpenSheet}>
                        <Text className="mb-0">{t.exam.customize.select_topics}</Text>
                        <div className="d-flex align-items-center">
                            <span className={`exam_customize_badge ${customized ? 'customized' : 'default'}`}>
                                {customized && <img src={check_img} alt="" />}
                                {customized ? t.exam.customize.customized_badge : t.exam.customize.randomly_drawn_badge}
                            </span>
                            <img src={right_img} alt="" className="ms-2" />
                        </div>
                    </div>
                </>
            }

            {hasTopics && !included &&
                <Text className="mb-0 mt-2 text-muted">{t.exam.customize.module_excluded}</Text>
            }

            {!hasTopics &&
                <Text className="mb-0 mt-2 text-muted">{t.exam.customize.fixed_module_notice}</Text>
            }

            {showTimeInput && included &&
                <div className="d-flex justify-content-between align-items-center mt-3 pt-3 border-top">
                    <Text className="mb-0">{t.exam.customize.module_time}</Text>
                    <Form.Control
                        type="number"
                        min={1}
                        value={time}
                        style={{ width: "80px" }}
                        onChange={(e) => onTimeChange(e.target.value)}
                    />
                </div>
            }
        </div>
    )
}
